import React from 'react';
import IguazuPageHardcoded from './IguazuPageHardcoded';
import './IguazuPage.css';

const IguazuPage: React.FC = () => {
  // Using hardcoded version with approved rainforest content and Art Initiatives section
  return <IguazuPageHardcoded />;
};

export default IguazuPage;